// src/pages/Moderation/ModerationQueuePage/ui/QueueQuickStats/QueueQuickStats.tsx
import React from 'react';
import './QueueQuickStats.scss';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';

type Props = {
  total: number;
  data: { keys: number[]; values: number[] };
  flags: GetFlagsResponse | null;
  title?: string;
  onPickFlag?: (flagValue: number) => void;
};

export const QueueQuickStats: React.FC<Props> = ({
  total,
  data,
  flags,
  title = 'Queue Quick Stats',
  onPickFlag,
}) => {
  const pct = (n: number) => (total > 0 ? Math.round((n / total) * 100) : 0);

  return (
    <section className="queue-quick-stats" aria-label="Queue quick statistics">
      <header className="queue-quick-stats__header">
        <h3 className="queue-quick-stats__title">{title}</h3>
        <div className="queue-quick-stats__total">
          <span className="queue-quick-stats__total-label">Total</span>
          <span className="queue-quick-stats__total-value">{total}</span>
        </div>
      </header>

      <div
        className="queue-quick-stats__grid"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${data.values.length}, minmax(0, 1fr))`,
          gap: 16,
        }}
      >
        {data.keys.map((flagValue, index) => (
          <button
            key={flagValue}
            type="button"
            className="queue-quick-stats__pill"
            title="Click to filter"
            onClick={() => onPickFlag?.(flagValue)}
          >
            <span className="queue-quick-stats__label">
              {flags?.data.find((f) => f.value === flagValue)?.description || `Flag ${flagValue}`}
            </span>
            <span className="queue-quick-stats__value">{data.values[index]}</span>
            <span className="queue-quick-stats__pct">{pct(data.values[index])}%</span>
          </button>
        ))}
      </div>
    </section>
  );
};
